import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AddPieceComponent } from './add-piece.component';
import {FormsModule} from "@angular/forms";


@NgModule({
  imports: [CommonModule,
    FormsModule,
  ],
  declarations: [AddPieceComponent],
  exports: [AddPieceComponent],
})
export class AddPieceModule {}
